import {
  CustomFieldType,
  CustomFieldValidators,
} from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { CustomFieldSubtype, getFieldSetting } from './utils'

export const FieldInput = ({
  field,
  name = undefined,
  onChange = undefined,
  value = undefined,
  ...rest
}) => {
  name = name || field.accessor || field.key
  const subtype = getFieldSetting(field, 'subtype')

  if (field.type === CustomFieldType.DATE) {
    return (
      <Form.Input
        name={name}
        onChange={e => {
          if (typeof onChange === 'function') onChange(e.target.value)
        }}
        type="date"
        className="py-1.5"
        {...rest}
      />
    )
  }

  if (field.type === CustomFieldType.BOOLEAN) {
    if (rest?.label) {
      if (subtype === CustomFieldSubtype.CHECKBOX) {
        return (
          <Form.Checkbox
            name={name}
            onChange={value => {
              if (typeof onChange === 'function') onChange(value)
            }}
            {...rest}
          />
        )
      }
      return (
        <Form.Toggle
          name={name}
          onChange={value => {
            if (typeof onChange === 'function') onChange(value)
          }}
          {...rest}
        />
      )
    }

    const items = [
      { text: 'Checked', value: true },
      { text: 'Unchecked', value: false },
    ]
    return (
      <Dropdown>
        <Dropdown.Button>
          {items?.find(item => item.value === value)?.text}
        </Dropdown.Button>
        <Dropdown.Items>
          {items.map(item => (
            <Dropdown.Item
              key={name}
              onClick={() => {
                if (typeof onChange === 'function') onChange(item.value)
              }}
            >
              {item.text}
            </Dropdown.Item>
          ))}
        </Dropdown.Items>
      </Dropdown>
    )
  }

  if (field.type === CustomFieldType.ARRAY) {
    if (field?.items?.validators?.length) {
      const enumValidator = field?.items?.validators?.find(
        validator => validator.validation === CustomFieldValidators.ENUM,
      )

      if (enumValidator?.value) {
        try {
          const validValues = JSON.parse(enumValidator.value) as string[]
          return (
            <Form.Multiselect
              name={name}
              onChange={value => {
                if (typeof onChange === 'function') onChange([value])
              }}
              options={validValues}
              {...rest}
            />
          )
        } catch (e) {
          logger.error('Could not parse enum array custom field validator')
        }
      }
    }
  }

  if (field.type === CustomFieldType.TEXT) {
    if (field?.validators?.length) {
      const enumValidator = field?.validators?.find(
        validator => validator.validation === CustomFieldValidators.ENUM,
      )

      if (enumValidator?.value) {
        try {
          const validValues = JSON.parse(enumValidator.value)

          if (rest?.label) {
            return (
              <Form.Select
                name={name}
                items={validValues?.map(value => ({
                  text: value || '-',
                  value,
                }))}
                onChange={value => {
                  if (typeof onChange === 'function') onChange(value)
                }}
                {...rest}
              />
            )
          }

          return (
            <Dropdown>
              <Dropdown.Button>{value}</Dropdown.Button>
              <Dropdown.Items>
                {validValues.map(value => (
                  <Dropdown.Item
                    key={name}
                    onClick={() => {
                      if (typeof onChange === 'function') onChange(value)
                    }}
                  >
                    {value}
                  </Dropdown.Item>
                ))}
              </Dropdown.Items>
            </Dropdown>
          )
        } catch (e) {
          logger.error('Could not parse enum custom field validator')
        }
      }
    }
  }

  let inputType
  if (subtype === CustomFieldSubtype.URL) inputType = 'url'
  if (subtype === CustomFieldSubtype.EMAIL) inputType = 'email'

  return (
    <Form.Input
      name={name}
      type={inputType}
      onChange={e => {
        if (typeof onChange === 'function') onChange(e.target.value)
      }}
      className="py-1.5"
      {...rest}
    />
  )
}
